<template>
  <div style="padding: 0">
    <detail acc-type="Shop" :hiddenLabel="true"/>
  </div>
</template>

<script>
import Detail from "@/components/shared/Conversations/Detail.vue";

export default {
  components: {
    Detail
  }
};
</script>

<style scoped>
</style>
